import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EmployeeDictionaryType, UpdateDictionaryEntryRequest } from '../../../models/employeeHub';
import { employeeDictionaryService } from '../services/employeeDictionaryService';
import { employeeDictionaryQueryKey } from '../../../hooks/queries/useEmployeeDictionary';

interface UpdateDictionaryEntryArgs {
    id: number;
    payload: UpdateDictionaryEntryRequest;
}

export const useUpdateDictionaryEntry = (type: EmployeeDictionaryType) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, payload }: UpdateDictionaryEntryArgs) =>
            employeeDictionaryService.update(type, id, payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: employeeDictionaryQueryKey(type) });
        },
    });
};
